
import externalConfiguration from '../external-configuration'

function deepTestM3u8( playlistUrl) {
  const baseUrl = playlistUrl.split('?')[0].split('/').slice(0,-1).join('/');
  return fetch( playlistUrl).then( response => {
    if( !response.ok) return Promise.reject( response);
    return response.text();
  }).then( response => {
    const chunklistPath = response.split('\n').reduce( (prev, next) => prev || next[0] !== '#' && next, null);
    if( !chunklistPath) return Promise.reject({ message: 'm3u8 without chunklist' });
    const chunklistUrl = `${baseUrl}/${chunklistPath}`;
    return fetch( chunklistUrl, { method: 'HEAD' });
  }).then( response => {
    if( !response.ok) return Promise.reject( response);
    return response;
  })
}

function contentTest( url) {    // TODO mejorar para que en vez de basarse en la extension, se base en las cabeceras para determinar si es m3u8
  const decomposedUrl = url.split('?');
  const query = `${decomposedUrl.length > 1 ? '&' : '?'}test`;
  const testUrl = `${url}${query}`;
  return fetch( testUrl, { method: 'HEAD' }).then( response => {
    if( !response.ok) return Promise.reject( response);
    if( decomposedUrl[0].slice( -5) === '.m3u8') {
      return deepTestM3u8( testUrl);
    }
    return response;
  });
}

function appendQueryString( url, params) {
  const start = (url && IE11_safeIncludes( url, '?')) ? '&' : '?';
  const objectParams = new URLSearchParams();
  let stringifiedParams = `${params}`;
  if( Array.isArray( params)) {
    params.forEach( param => {
      if( Array.isArray( param)) objectParams.append( param[0], param[1]);
      else objectParams.append( param, '');
    });
    stringifiedParams = `${objectParams}`;
  } else if(!(typeof params === 'string' || params instanceof String)) {
    Object.keys(params).forEach( param => {
      objectParams.append( param, params[param]);
    });
    stringifiedParams = `${objectParams}`;
  }
  if( stringifiedParams === '') return url;
  return `${url}${start}${stringifiedParams}`;
}

function patchM3u8ForOldIos( url) {
  // console.log( 'patchM3u8ForOldIos');   // DEBUG
  const IosVersion = iosVersion();
  if( url && IosVersion >= 0 && IosVersion <= 10) {
    const match = /_H,([0-9]+)(,([0-9]+))*,.mp4.m3u8(\?.*)?$/.exec( url);
    if( match) {
      if( match[2]) {
        url = url.replace( /_H,([0-9]+)(,([0-9]+))*,.mp4.m3u8(\?.*)?$/, '_H$3.mp4.m3u8$4');
      } else {
        url = url.replace( /_H,([0-9]+),.mp4.m3u8(\?.*)?$/, '_H$1.mp4.m3u8$2');
      }
    }
  }
  return url;
}

function patchHttpsFromJson( url) {
  // console.log( 'patchHttpsFromJson');   // DEBUG
  if( url && window.location.protocol === 'https:') {
    url = url.replace( /^http:/, 'https:');
  }
  return url;
}

function avoidCache( url, plusPatches = true){
  // console.log( 'avoidCache');   // DEBUG
  if( plusPatches) {
    url = patchM3u8ForOldIos( url);
    url = patchHttpsFromJson( url);
  }
  return appendQueryString( url, { t: Date.now()});
}

function patchM3u8Url( url) {
  // console.log( 'patchM3u8Url');   // DEBUG
  url = patchM3u8ForOldIos( url);
  url = patchHttpsFromJson( url);
  // url = avoidCache( url, false);
  return url;
}

function hashCode(str) {
  return ( str + '' ).split('').reduce((prevHash, currVal) =>
    (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
}

// function extractMp4FromM3u8( m3u8Url) {
//   if( /\.m3u8(\?.*)?$/.exec( m3u8Url)) {
//     const a = /^(https?:)?\/\/[^/]+\/(.*)_H,(([0-9]+),)+\.mp4\.m3u8(\?.*)?$/.exec( m3u8Url);
//     if( a) return externalConfiguration.cdnVideosDomain + '/' + a[2] + '_H' + a[4] + '.mp4';
//     return undefined;
//   }
//   return m3u8Url;
// }

function iosVersion() {
  let version = -1;
  if( navigator.platform.match(/iPad|iPhone|iphone|iPod/)) {
    version = parseInt( navigator.userAgent.match(/OS ([0-9]+)(_[0-9]+)*/)[1], 10);
  }
  return version;
}

function isIE11() {
  return (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0);
}

function IE11_safeIncludes( searchable, target) {
  let ret = false;
  if( searchable) {
    if( searchable.includes) {
      ret = searchable.includes( target);
    } else if( searchable.indexOf) {
      ret = searchable.indexOf( target) !== -1;
    }
  }
  return ret;
}

function IE11_safeFrameElement() {
  try {
    return window.frameElement;
  } catch( _) {};
  return null;
}

function arrayShuffle( list) {
  return list.map( e => [ Math.random(), e]).sort().map( e => e[1]);
}

function promiseSome( n, promises) {
  let rejected = [], resolved = [];
  return Promise.race( promises.map( promiseOrValue => Promise.resolve( promiseOrValue)).map( ( promise, i) => {
    return promise.then( value => {
      return resolved.push( { value, i}) === n ? Promise.resolve( resolved) : Promise.race([]);
    }).catch( value => {
      return rejected.push( { value, i}) + n > promises.length ? Promise.reject( rejected) : Promise.race([]);
    });
  }));
}

function promiseAny( promises) {
  return promiseSome( 1, promises).then( resolved => resolved[0].value);
}

export { appendQueryString, avoidCache, patchM3u8Url, patchHttpsFromJson, hashCode, iosVersion, isIE11, IE11_safeIncludes, promiseSome, promiseAny, IE11_safeFrameElement, arrayShuffle, contentTest };



// WEBPACK FOOTER //
// ./src/helpers/utils.js